import { DropDownListProps } from "@progress/kendo-react-dropdowns";
import { filterBy } from "@progress/kendo-data-query";
import { ComponentState, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getStaffListData } from "../globalDataCheckerService";
import DropDownListComponent from "src/control-components/drop-down-component/drop-down";

export const StaffDropDownComponent = (props: SiteDdlProps) => {
    const state: ComponentState = useSelector(states => {
        return states;
    });

    const { selectedStaff, onChangeStaff, disabled, isCheckActiveStaff, switchStaffValue, ...rest } = props
    const [filter, setFilter] = useState<any>();
    const { staffsList } = state['DocumentReducer'];
    const [staffList, setStaffList] = useState([]);
    const [loading, setLoading] = useState(false)
    const [isDataLoadStart, setDataLoadStart] = useState(false);

    function onFilterChange(event, listName) {
        setFilter({ ...filter, [listName]: event.filter });
    }
    useEffect(() => {

        if (!isDataLoadStart) {
            setLoading(true)
            callStaffListApiData()
            setDataLoadStart(true)
        }
        if (staffsList != null) {
            setLoading(false)
            setStaffList(staffsList);
        }
    }, [isDataLoadStart, staffsList])

    const callStaffListApiData = async () => {
        getStaffListData(isCheckActiveStaff, switchStaffValue)
    }

    return <div className="">
        <div className="p-0 col-md-12 pr-3 pl-3">
            <div className="position-relative d-inline-block w-100 topSpacing">
                <DropDownListComponent
                    filterable={true}
                    data={filterBy(staffList, filter ? filter.staffList : [])}
                    onFilterChange={(event) => {
                        onFilterChange(event, "staffList");
                    }}
                    loading={loading}
                    textField="name"
                    label="Staff"
                    name="site"
                    value={selectedStaff}
                    onChange={onChangeStaff}
                />
            </div>
        </div>
    </div>
}

export interface SiteDdlProps {
    selectedStaff: any,
    isCheckActiveStaff: boolean,
    switchStaffValue: any,
    disabled: any
    onChangeStaff?: (newValue: DropDownListProps) => void
}